import { Box, Grid } from '@mui/material';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import { PmiButton } from 'shell/components/shared/button';
import { StickyDiv } from 'shell/components/shared/sticky-div';

interface SubscriptionButtonsProps {
  handleExit: () => void;
}

const SubscriptionButtons: React.FC<SubscriptionButtonsProps> = ({
  handleExit,
}: SubscriptionButtonsProps) => {
  return (
    <Grid item xs={12} md={2}>
      <StickyDiv>
        <StepButton active fullWidth>
          <StepTypography active>Anagrafe</StepTypography>
        </StepButton>
        <div className="pmi-pt-4">
          <div className="pmi-pb-2">
            <PmiButton color="cdmBrandThird" variant="outlined" id="submit" fullWidth type="submit">
              Conferma
            </PmiButton>
          </div>
          <div className="pmi-pb-2">
            <PmiButton
              color="cdmBrand"
              variant="contained"
              id="deny-operation"
              fullWidth
              onClick={handleExit}
            >
              <Box
                sx={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}
              >
                Annulla Operazione
              </Box>
            </PmiButton>
          </div>
        </div>
      </StickyDiv>
    </Grid>
  );
};

SubscriptionButtons.displayName = 'Buttons subscriptions component';

export default SubscriptionButtons;
